import React from 'react';
import { Row, Col, Modal, Button } from 'antd';
import { ModalFuncProps } from 'antd/lib/modal';
import { LinkOutlined } from '@ant-design/icons';
import LatexDemo from './LatexDemo';

export function FormHelpInfo(): JSX.Element {
  return (
    <>
      <h2>📝 Write Rich, Detailed Notes</h2>
      <Row>
        <Col lg={12} sm={24}>
          <h5>Full Markdown Support</h5>
          <p>
            Enhance your notes with Markdown features like creating lists, italicizing and bolding important content,
            making tables, and more.
          </p>
          <a href="https://devhints.io/markdown" target="_blank" rel="noopener noreferrer">
            <Button shape="round" icon={<LinkOutlined />}>
              Markdown Cheatsheet
            </Button>
          </a>
        </Col>
        <Col lg={12} sm={24}>
          <h5>Embedded Math</h5>
          <p>Use LaTeX to render mathematical equations and scientific symbols. Just wrap your math in dollar signs!</p>
          <p>
            To write dollar signs without triggering the math rendering, escape them with slashes: &quot;\$ this will
            not be math \$&quot;
          </p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col lg={24}>
          <h6>Try it yourself:</h6>
          <div>
            <LatexDemo />
          </div>
        </Col>
      </Row>
    </>
  );
}

export default function HelpModal({ open, onCancel, onOk }: ModalFuncProps): JSX.Element {
  return (
    <div>
      <Modal open={open} onCancel={onCancel} onOk={onOk} destroyOnHidden footer={null} width="70%">
        <FormHelpInfo />
      </Modal>
    </div>
  );
}
